module.exports = __webpack_public_path__ + "static/grid_screenshot-178b8e79af0b452a73116c33682772fd.png";